import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onChange", "options", "placeholder", "searchable", "buttonUse", "onSearchChange", "value"];
import { Controllable } from '../Controllable';
import { Typeahead } from '../Typeahead/Typeahead';
import { lazyEval } from '../../utils/lazyEval';
import devLogger from 'react-utils/devLogger';
import { DropdownSelectProvider } from '../Dropdown/utils/DropdownSelectProvider';
import { Dropdown } from './Dropdown';
import unescapedText from 'I18n/utils/unescapedText';
import { jsx as _jsx } from "react/jsx-runtime";
export const DropdownSelectComponent = _ref => {
  let {
      onChange,
      options,
      placeholder = unescapedText('salesUI.UIDropdownSelect.placeholder'),
      searchable = false,
      buttonUse = 'transparent',
      onSearchChange,
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const selectedOption = options.find(option => option.value === value);

  // Warn about groups in development
  if (process.env.NODE_ENV !== 'production') {
    options.forEach(option => {
      if (option.options) {
        devLogger.warn({
          message: 'DropdownSelect: The given `options` include groups, which are not supported. ' + 'Use `Select` instead.',
          key: 'DropdownSelect-groups',
          url: 'https://git.hubteam.com/HubSpot/UIComponents/issues/6467'
        });
      }
    });
  }
  return /*#__PURE__*/_jsx(DropdownSelectProvider, {
    isDropdownSelect: true,
    children: /*#__PURE__*/_jsx(Dropdown, Object.assign({
      buttonUse: buttonUse,
      buttonText: selectedOption ? selectedOption.text : lazyEval(placeholder),
      isDropdownSelect: searchable,
      hasSearchbox: searchable,
      placement: "bottom left"
    }, rest, {
      children: /*#__PURE__*/_jsx(Typeahead, {
        minimumSearchCount: searchable ? 0 : Infinity,
        options: options,
        onChange: onChange,
        onSearchChange: onSearchChange,
        autoFocus: true
      })
    }))
  });
};
export const DropdownSelect = Controllable(DropdownSelectComponent, ['open', 'value']);